import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { EstimatedTradeCostOptimization } from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { EstimatedTradeCostComparisonColumn } from 'widgets/estimatedTradeCost/widget-comparison/components/grid/columns';
import { SortDirection } from '@instinet-analytics/core-lib';

export type EstimatedTradeCostComparisonConfigState = {
    collapseLeftHandPanel?: boolean;
    optimizations: Array<EstimatedTradeCostOptimization>;
} & WidgetConfigWithHideableToolbar &
    ConfigStateWithGridSupport<EstimatedTradeCostComparisonColumn>;

export const getInitialEstimatedTradeCostComparisonConfigState: () => EstimatedTradeCostComparisonConfigState =
    () => ({
        optimizations: [],
        visibleColumns: [
            'benchmark',
            'profile',
            'totalCost',
            'totalRisk',
            'efPart',
            'startTime',
            'endTime',
        ],
        sort: [
            { colId: 'benchmark', sort: SortDirection.ASCENDING },
            { colId: 'profile', sort: SortDirection.ASCENDING },
        ],
        columnWidths: {
            benchmark: 55,
            profile: 60,
            minPartLit: 75,
            maxPartLit: 75,
            strikeTime: 75,
            totalCost: 90,
            totalRisk: 90,
            efPart: 75,
            startTime: 90,
            endTime: 90,
        },
        hideToolbar: false,
    });
